import type { IconDef } from '../types';

export const add: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12 0C18.6218 0 24 5.37818 24 12C24 18.6218 18.6218 24 12 24C5.37818 24 0 18.6218 0 12C1.93648e-07 5.37818 5.37818 1.93642e-07 12 0ZM17.1816 3.66504C12.9271 1.0144 7.14522 2.59667 4.28711 7.2002C1.4291 11.8038 2.56388 17.695 6.81836 20.335C11.0729 22.9747 16.8548 21.3817 19.7129 16.7891V16.7998C22.5709 12.1962 21.4361 6.305 17.1816 3.66504ZM12.5459 6.5459C13.1457 6.54614 13.6367 7.03687 13.6367 7.63672V11.4541H17.4541C18.0541 11.4541 18.5459 11.9459 18.5459 12.5459C18.5457 13.1457 18.054 13.6367 17.4541 13.6367H13.6367V17.4541C13.6367 18.054 13.1457 18.5457 12.5459 18.5459C11.9459 18.5459 11.4541 18.0541 11.4541 17.4541V13.6367H7.63672C7.03687 13.6367 6.54614 13.1457 6.5459 12.5459C6.5459 11.9459 7.03672 11.4541 7.63672 11.4541H11.4541V7.63672C11.4541 7.03672 11.9459 6.5459 12.5459 6.5459Z',
    },
  ],
};
